import { createContext, useContext, useState, useCallback } from "react";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("it");
  const toggle = useCallback(() => setLang((l) => (l === "it" ? "en" : "it")), []);
  return (
    <LangContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

export const ROUTES = [
  { path: "/", key: "home" },
  { path: "/operazioni-immobiliari", key: "operazioni" },
  { path: "/valorizzazione", key: "valorizzazione" },
  { path: "/ristrutturazioni", key: "ristrutturazioni" },
  { path: "/general-contractor", key: "generalContractor" },
  { path: "/consulenza", key: "consulenza" },
  { path: "/saldo-e-stralcio", key: "saldo" },
  { path: "/chi-siamo", key: "chisiamo" },
  { path: "/contatti", key: "contatti" },
];

export const COSA_FACCIAMO_PATHS = [
  "/operazioni-immobiliari",
  "/valorizzazione",
  "/ristrutturazioni",
  "/general-contractor",
  "/consulenza",
];

export const shared = {
  it: {
    nav: {
      home: "Home",
      cosafacciamo: "Cosa Facciamo",
      operazioni: "Investimenti Immobiliari",
      valorizzazione: "Valorizzazione",
      ristrutturazioni: "Ristrutturazioni",
      generalContractor: "General Contractor",
      consulenza: "Consulenza",
      saldo: "Saldo e Stralcio",
      chisiamo: "Chi Siamo",
      contatti: "Contatti",
    },
    ctaHeader: "Parlaci del tuo immobile",
    ctaValutazione: "Richiedi una valutazione",
    ctaSituazione: "Parlaci della situazione",
    menuOpen: "Menu",
    menuClose: "Chiudi",
    footerTagline: "Investimenti e valorizzazione immobiliare.",
    footerNav: "Navigazione",
    footerContatti: "Contatti",
    footerLegal: "Legale",
    privacy: "Privacy Policy",
    cookie: "Cookie Policy",
    rights: "Tutti i diritti riservati.",
    wordmarkSub: "Real Estate Investments",
    upcoming: "Prossime aperture — Como (CO) · Monza (MB)",
  },
  en: {
    nav: {
      home: "Home",
      cosafacciamo: "What We Do",
      operazioni: "Real Estate Investment",
      valorizzazione: "Value Creation",
      ristrutturazioni: "Renovations",
      generalContractor: "General Contractor",
      consulenza: "Advisory",
      saldo: "Distressed Settlements",
      chisiamo: "About",
      contatti: "Contact",
    },
    ctaHeader: "Tell us about your property",
    ctaValutazione: "Request an assessment",
    ctaSituazione: "Tell us about the situation",
    menuOpen: "Menu",
    menuClose: "Close",
    footerTagline: "Real estate investment and value creation.",
    footerNav: "Navigation",
    footerContatti: "Contact",
    footerLegal: "Legal",
    privacy: "Privacy Policy",
    cookie: "Cookie Policy",
    rights: "All rights reserved.",
    wordmarkSub: "Real Estate Investments",
    upcoming: "Upcoming locations — Como (CO) · Monza (MB)",
  },
};

export const CONTACTS = {
  phone: "+39 348 893 9970",
  phoneHref: "tel:+393488939970",
  whatsapp: "https://wa.me/393488939970",
  email: "nikysrl3@gmail.com",
  address: "Viale Monza 355, 20126 Milano (MI)",
};
